"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileSidebar = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var MobileContainer_1 = require("./MobileContainer");
var Sidebar_1 = __importDefault(require("./Sidebar"));
var MOBILE_SIDEBAR_MENUS = [
    { id: "pages", display: "Pages", component: function (props) { return react_1.default.createElement(MobilePagesSubmenus, __assign({}, props)); } },
    { id: "reports", display: "Reports", component: function (props) { return react_1.default.createElement(MobileReportsSubmenus, __assign({}, props)); } },
];
var MobilePagesSubmenus = function (_a) {
    var $state = _a.$state, activeNav = _a.activeNav, onFolderSelect = _a.onFolderSelect, props = __rest(_a, ["$state", "activeNav", "onFolderSelect"]);
    return (react_1.default.createElement(Sidebar_1.default, __assign({}, props, { onFolderSelect: function (selectedFolder) {
            onFolderSelect(selectedFolder);
            if (activeNav !== "pages") {
                $state.go("dashboard", { nav: "pages" });
            }
        } })));
};
var MobileReportsSubmenus = function (_a) {
    var $state = _a.$state, activeNav = _a.activeNav, setIsMobileSidebarOpen = _a.setIsMobileSidebarOpen;
    var goToNav = function (navName) {
        setIsMobileSidebarOpen(false);
        $state.go("dashboard", { nav: navName });
    };
    return (react_1.default.createElement("div", { className: "siderbar__mobile__submenu-items" },
        react_1.default.createElement(kaleidoscope_1.Button, { width: "full", type: kaleidoscope_1.ButtonType.Tertiary, onClick: function () { return goToNav("reports"); } },
            react_1.default.createElement(icons_1.Velocity, { className: activeNav === "reports" ? "actived" : "" }),
            "Pipeline")));
};
function MobileSidebar(props) {
    var _a;
    var isMobileSidebarOpen = props.isMobileSidebarOpen, setIsMobileSidebarOpen = props.setIsMobileSidebarOpen, activeNav = props.activeNav;
    var _b = __read((0, react_1.useState)(MOBILE_SIDEBAR_MENUS.findIndex(function (_a) {
        var id = _a.id;
        return id === activeNav;
    })), 2), selectedMenu = _b[0], setSelectedMenu = _b[1];
    return (react_1.default.createElement(MobileContainer_1.MobileContainer, { isMobileSidebarOpen: isMobileSidebarOpen, setIsMobileSidebarOpen: setIsMobileSidebarOpen, menuComponents: react_1.default.createElement(MobileSidebarMenus, { selectedMenu: selectedMenu, onMenuSelected: setSelectedMenu }) },
        react_1.default.createElement("div", { className: "siderbar__mobile__content" }, (_a = MOBILE_SIDEBAR_MENUS[selectedMenu]) === null || _a === void 0 ? void 0 : _a.component(props))));
}
exports.MobileSidebar = MobileSidebar;
function MobileSidebarMenus(_a) {
    var selectedMenu = _a.selectedMenu, onMenuSelected = _a.onMenuSelected;
    return (react_1.default.createElement("div", { className: "siderbar__mobile__menus" }, MOBILE_SIDEBAR_MENUS.map(function (menu, index) { return (react_1.default.createElement("button", { key: menu.id, className: "siderbar__mobile__menus__button", onClick: function () { return onMenuSelected(index); } },
        react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", className: selectedMenu === index ? "selected" : "unselected" }, menu.display))); })));
}
